 
import { Fragment } from 'react';
import classNames from 'classnames';
import * as queryString from 'query-string';
import {
  withRouter,
  RouteComponentProps,
} from 'react-router-dom';
import type { LocationDescriptor } from 'history';

import { Link } from '@ui/Link';

// styles
import s from './LinkFilter.sss';

// types
export type Item = {
  text: string;
  href?: string;
  subItems?: Item[] | null;
  active?: boolean;
  external?: boolean;
  count?: number;
  onChooseFilter?: (item: Item) => void;
  [key: string]: unknown;
};

export type LinkFilterProps = {
  items: Item[];
  className?: string;
  filterParam?: string;
  filterValueKey?: string;
  external?: boolean;
  initialTreeLevel?: number;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void,
};

// If item is active or item contains active child
export const containsActive = (
  item: Item,
  property: string,
  activeItemValue: string,
): boolean => (
  item[property] === activeItemValue
     
    || !!item?.subItems?.length
     
    && item.subItems.some((subItem) => containsActive(subItem, property, activeItemValue))
);

const LinkFilter: React.FC<LinkFilterProps & RouteComponentProps> = ({
  items,
  className,
  filterParam,
  filterValueKey,
  location,
  initialTreeLevel = 1,
  onClick,
  ...args
}) => (
  <ul className={className}>
    {
      items.map((
        item,
        key,
      ) => {
        let isFilterActive = item.active;
        let isSubFilterActive = false;
        let linkTo: LocationDescriptor = item.href || '';
        if (filterParam && filterValueKey) {
          const searchParams = queryString.parse(location.search);

          isFilterActive = searchParams[filterParam] === item[filterValueKey];
          if (!isFilterActive && item.subItems) {
            isSubFilterActive = containsActive(
              item,
              filterValueKey,
              searchParams[filterParam],
            );
          }

          searchParams[filterParam] = item[filterValueKey];
          linkTo = {
            pathname: location.pathname,
            search: queryString.stringify(searchParams),
          };
        }
        const shouldRenderSubItems = initialTreeLevel - 1 > 0;

        return (
          <Fragment key={key}>
            <li>
              <Link
                theme="black"
                className={classNames(
                  s.link,
                  { [s.activeLink]: isFilterActive },
                )}
                {...(
                  item.external
                    ? { href: linkTo.toString() }
                    : { to: linkTo }
                )}
                onClick={onClick}
              >
                {item.text}
                <span className={s.count}>{item.count}</span>
              </Link>
            </li>
            {
              (isFilterActive || isSubFilterActive || shouldRenderSubItems)
              && item.subItems
              && (
              <LinkFilter
                className={s.subFilter}
                items={item.subItems}
                filterParam={filterParam}
                filterValueKey={filterValueKey}
                location={location}
                onClick={onClick}
                initialTreeLevel={initialTreeLevel - 1}
                {...args}
              />
              )
            }
          </Fragment>
        );
      })
    }
  </ul>
);

export default withRouter(LinkFilter);
